export default "/048cb1f2b29308e18768c65cfd51e426596a830c/08ee3b32e72dd5b2b700754671ea2016.svg";